import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import IconBack from "../../Resources/svg/Icons/IconBack";

import { modalSteps } from "../../Store/simulate/actions";

interface Navigation {
  position: number;
  subtitle?: string;
  title: string;
  hidden?: boolean;
  justBack?: boolean;
}

declare global {
  interface Window {
    digitalData: any[];
  }
}

const NavResponsive = ({ position = 1, subtitle, title, hidden, justBack }: Navigation) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleBack = () => {
    justBack ? history.goBack() : dispatch(modalSteps(true))
  };

  return (
    <div className="nav-responsive">
      <div className="content-box">
        <div
          className={`nav-responsive__routing ${
            hidden !== true ? "" : "nav-responsive__border-hidden"
          }`}
        >
          <IconBack className="nav-case__back" onClick={handleBack} />
          {hidden !== true ? (
            <>
              <div className="nav-responsive__step">Paso {position} de 7</div>
              <progress max="100" value={position * 14.2857}></progress>
            </>
          ) : (
            <div className="back-responsive__text">Volver</div>
          )}
        </div>
        {hidden !== true && (
          <div className="nav-responsive__subtitle">
            {subtitle ? subtitle : "Realizar cotización"}
          </div>
        )}

        <div className="nav-responsive__title">
          {title ? title : "Datos personales"}
        </div>
      </div>
    </div>
  );
};

export default NavResponsive;
